export const PAGINATION_CURRENT_PAGE = 0;
export const PAGINATION_START = 0;
export const PAGINATION_LIMIT = 50;

export const COLUMNS = [
  {
    field: "clientName",
    header: "Nom",
    resizeable: true,
    alignHeader: 'center',
    align: 'left',
    style: {
      width: "180px"
    },
  },
  {
    field: "manager.name",
    header: "GD",
    alignHeader: 'center',
    style: {
      width: '160px'
    }
  },
  {
    field: "rdv",
    header: "RDV Date",
    alignHeader: 'center',
    style: {
      width: "160px"
    },
  },
  {
    field: "comment",
    header: "Commentaire",
    alignHeader: 'center',
    align: 'center',
    style: {
      width: "500px"
    },
  },
  {
    field: "status",
    header: "Client récupéré",
    alignHeader: 'center',
    align: 'center',
    style: {
      width: "100px"
    },
  },
  {
    field: "actions",
    header: "Actions",
    alignHeader: 'center',
    align: 'center',
  },
];
